import { Material } from '@app/store/shared';
import { LessonDto, MediaDto } from './lesson.dto';
import { LessonType } from './lesson.type';

export class Lesson {
    id: string;
    name: string;
    placeholder: string;
    title: string;
    description: string;
    duration: number;
    media: Media;
    materials: Material[];
    transcription: string;

    constructor(data: LessonDto) {
        this.id = data.id;
        this.name = data.name;
        this.placeholder = data.placeholder;
        this.title = data.title;
        this.description = data.description;
        this.duration = data.duration;
        this.media = new Media(data.media);
        this.transcription =
            data.transcription ??
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi.<br />Proin porttitor, orci nec nonummy molestie, enim est eleifend mi, non fermentum diam nisl sit amet erat. Duis semper. Duis arcu massa, scelerisque vitae, consequat in, pretium a, enim. Pellentesque congue.<br />Ut in risus volutpat libero pharetra tempor. Cras vestibulum bibendum augue. Praesent egestas leo in pede. Praesent blandit odio eu enim. Pellentesque sed dui ut augue blandit sodales.<br />Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Aliquam nibh. Mauris ac mauris sed pede pellentesque fermentum. Maecenas adipiscing ante non diam sodales hendrerit.<br />Ut velit mauris, egestas sed, gravida nec, ornare ut, mi. Aenean ut orci vel massa suscipit pulvinar. Nulla sollicitudin. Fusce varius, ligula non tempus aliquam, nunc turpis ullamcorper nibh, in tempus sapien eros vitae ligula.';
        this.materials = data.materials?.map((material) => new Material(material)) ?? [];
    }
}

export class Media {
    type: LessonType;
    id: string;

    constructor(data: MediaDto) {
        this.type = data.type;
        this.id = data.id;
    }
}
